import React from 'react'
import TimeInputJS from './TimeInputJS'

interface IDatetimeInputProps {
  defaultValue?: string
  minValue?: string
  maxValue?: string
  onChange: (value: string) => void
  onEntered?: (value: string) => void
}

const TimeInput: React.FC<IDatetimeInputProps> = ({
  defaultValue,
  minValue,
  maxValue,
  onChange,
  onEntered,
}) => {
  return (
    <TimeInputJS
      defaultValue={defaultValue}
      minValue={minValue}
      maxValue={maxValue}
      onChange={onChange}
      onEntered={onEntered}
    />
  )
}
export default TimeInput
